import React, {ReactComponentElement} from "react";
import getStore, {history} from "../store";
import {render} from "@testing-library/react";
import { Provider } from "react-redux";
import {ConnectedRouter} from "connected-react-router";

export const renderWithProviders = (ui:ReactComponentElement<any>, preloadedState:any = undefined) => {
    const store = getStore(preloadedState)
    return render(
        <Provider store={store}>
            <ConnectedRouter history={history}>
                {ui}
            </ConnectedRouter>
        </Provider>
    );
}

export const SuccessElement = () => {
  return (
    <>
      <h1>Success Page</h1>
      <p>This is a mock success page used for testing purposes only.</p>
    </>
  )
}